export default __webpack_public_path__ + "static/category-solar-60576227f82a8fe5f67f7706f5457f12.png";